export default __webpack_public_path__ + "static/media/sn22.8727823f.jpg";